var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar",class:{'tab-bar_inline': _vm.inline}},[_vm._t("default",_vm._l((_vm.data),function(item){return _c('tab',{key:item.label,attrs:{"label":item.label,"icon":item.icon}})})),_vm._v(" "),(_vm.showSlider)?_c('div',{ref:"slider",staticClass:"tab-bar-slider"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-291dbb83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tabs.vue
// module id = null
// module chunks = 